import clsx from 'clsx';
import React from 'react';
import { Link } from 'react-router-dom';
import separator_svg from '../../../static/other/separator.svg';

const english_alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";

const check = <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" clipRule="evenodd" d="M1.70711 5.2929C1.31658 4.90238 0.683418 4.90238 0.292893 5.2929C-0.0976311 5.68343 -0.0976311 6.31659 0.292893 6.70712L5.29289 11.7071C5.69802 12.1122 6.36002 12.0948 6.74329 11.669L15.7433 1.66897C16.1128 1.25846 16.0795 0.626173 15.669 0.256714C15.2585 -0.112745 14.6262 -0.0794662 14.2567 0.331044L5.96181 9.5476L1.70711 5.2929Z" /></svg>;

const chevron = <svg width="13" height="5" viewBox="0 0 13 5" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
  <path d="M1 1.00012L6.5 4.00012L12 1.00012" stroke="var(--text)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
</svg>;

function Separator(props) {
  return <img src={separator_svg} alt="" {...props}></img>;
}

/*
  The list in the task page sidebar: "back" link + archive seasons / search results / similar tasks.
  Desktop & tablet: the sidebar column. Phones: a compact block above the statement, the list collapsed
  behind a toggle (the toggle is display: none on wider screens, where the list is always shown).
*/
export class TaskSearchList extends React.Component {
  constructor(props) {
    super(props);

    this.search_context = new URLSearchParams(window.location.search);

    this.state = {
      active: props.location.state || this.search_context.get("archive") ? undefined : null,
      open_seasons: {}, // season index -> opened/closed by the user; otherwise the active task's season is open
      expanded: false,
    };
  }

  componentDidUpdate() {
    if (this.props.search && this.props.task_data && this.props.task_data !== "bad_data" && this.state.active === undefined) {
      this.setState({ active: this.props.task_data.id, });
    }
  }

  isSeasonOpen(season, index) {
    return this.state.open_seasons[index] ?? (
      season.tasks.some(element => element.id === this.state.active) || this.state.active === "result" + season.source_contest
    );
  }

  // another task picked in the list (the task page isn't remounted): on phones collapse the list and
  // bring the new statement into view
  selectItem(id, state) {
    this.props.updateTaskData(id);
    this.setState({ active: id, expanded: false, ...state, });
    window.scrollTo(0, 0);
  }

  // navigating inside the archive must not collapse the seasons that are open right now
  selectArchiveItem(id) {
    this.selectItem(id, {
      open_seasons: Object.fromEntries(this.props.search.seasons.map((season, index) => [index, this.isSeasonOpen(season, index)])),
    });
  }

  backLink() {
    const archive = this.props.search ? this.props.search.type === "archive" : this.search_context.get("archive");
    if (archive) {
      const href = new URLSearchParams(this.search_context.toString());
      href.delete("archive");
      return <Link className="task-search-back" to={"/contest" + (href.toString() ? "?" + href.toString() : "")}>
        ← К соревнованиям
      </Link>;
    }
    const state = this.props.location.state;
    return <Link className="task-search-back" to={{
      pathname: "/tasks",
      state: {
        ...(state || { category: "public", }),
        // came from the public list: it scrolls back to this task's row
        task: state?.category === "public" ? this.props.task_data?.id : undefined,
      },
    }}>
      ← К списку задач
    </Link>;
  }

  renderArchive() {
    return <>
      <p className="task-search-title task-search-title--archive">{this.props.search.name}</p>
      {this.props.search.seasons.map((season, index) => {
        const open = this.isSeasonOpen(season, index);
        return <div key={index} className={clsx("task-archive-dropdown", open && "open")}>
          <Separator />
          <button
            type="button"
            className="task-archive-dropdown-title"
            aria-expanded={open}
            onClick={() => this.setState({ open_seasons: { ...this.state.open_seasons, [index]: !open, }, })}
          >
            <span>{season.name}</span>
            {chevron}
          </button>
          <div className="task-archive-dropped">
            {season.tasks.map((element, index) => {
              const number = season.tasks.length <= 26 ? english_alphabet[index] : index;
              if (this.state.active === element.id) {
                return <ul key={index}><span className="task-link-current">{number}. {element.name}</span></ul>;
              }
              return <ul key={index}><Link
                to={"/tasks/" + element.id + window.location.search}
                onClick={() => this.selectArchiveItem(element.id)}
              ><div>{number}. {element.name}</div></Link></ul>;
            })}
            {season.hasOwnProperty("source_contest") && (
              this.state.active === "result" + season.source_contest ?
                <ul><span className="task-link-current">Результаты</span></ul> :
                <ul><Link
                  to={"/tasks/result" + (() => {
                    this.search_context = new URLSearchParams(this.props.location.search);
                    if (this.search_context.get("result")) {
                      this.search_context.set("result", season.source_contest);
                      return "?" + this.search_context.toString();
                    } else {
                      return this.props.location.search + "&result=" + season.source_contest;
                    }
                  }).call()}
                  onClick={() => this.selectArchiveItem("result" + season.source_contest)}
                >Результаты</Link></ul>
            )}
          </div>
        </div>;
      })}
    </>;
  }

  renderSearchResults() {
    return <>
      <p className="task-search-title task-search-title--results">Результат поиска</p>
      {this.props.search.values.map((element, index) => {
        const label = <>{element.solved ? check : element.id + "."} {element.name}</>;
        if (this.state.active === element.id) {
          return <ul key={index}><span className="task-link-current">{label}</span></ul>;
        }
        return <ul key={index}><Link
          to={{
            pathname: `/tasks/${element.id}`,
            state: this.props.location.state,
          }}
          onClick={() => this.selectItem(element.id)}
        ><div>{label}</div></Link></ul>;
      })}
    </>;
  }

  renderSimilar() {
    return <>
      <p className="task-link-current">{this.props.task_data.id}. {this.props.task_data.name}</p>
      {this.props.search.values.length > 0 && <>
        <p className="task-search-title task-search-title--similar">Похожие задачи</p>
        {this.props.search.values.map((element, index) => <ul key={index}><Link
          to={"/tasks/" + element.id + window.location.search}
          onClick={() => this.props.refreshPage()}
        ><div>{element.id}. {element.name}</div></Link></ul>)}
      </>}
    </>;
  }

  render() {
    const search = this.props.search;
    let section = null;
    if (search?.type === "archive") {
      section = { title: search.name, body: this.renderArchive(), };
    } else if (search && this.props.location.state) {
      section = { title: "Результат поиска", count: search.values.length, body: this.renderSearchResults(), };
    } else if (search) {
      section = { title: "Похожие задачи", count: search.values.length, body: this.renderSimilar(), };
    }

    return <div className={clsx("task-list-scroll-wrapper", "task-search-list", this.state.expanded && "expanded")}>
      {this.backLink()}
      {section && section.count !== 0 && <button
        type="button"
        className="task-search-toggle"
        aria-expanded={this.state.expanded}
        onClick={() => this.setState({ expanded: !this.state.expanded, })}
      >
        <span className="task-search-toggle__title">{section.title}</span>
        {section.count > 0 && <span className="task-search-toggle__count">{section.count}</span>}
        {chevron}
      </button>}
      {section && <div className="task-search-body">{section.body}</div>}
    </div>;
  }
}
